module.exports = __webpack_public_path__ + "static/scale-model-of-visit-wichita-in-wichita-kansas-d52a105953c231002fdf5ab2c98628a3.png";